/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResearchSession } from './ResearchSession';
import {
    ResearchSessionFromJSON,
    ResearchSessionFromJSONTyped,
    ResearchSessionToJSON,
    ResearchSessionToJSONTyped,
} from './ResearchSession';

/**
 * A response to a research session request
 * @export
 * @interface ResearchSessionResponse
 */
export interface ResearchSessionResponse {
    /**
     * 
     * @type {ResearchSession}
     * @memberof ResearchSessionResponse
     */
    researchSession: ResearchSession;
}

/**
 * Check if a given object implements the ResearchSessionResponse interface.
 */
export function instanceOfResearchSessionResponse(value: object): value is ResearchSessionResponse {
    if (!('researchSession' in value) || value['researchSession'] === undefined) return false;
    return true;
}

export function ResearchSessionResponseFromJSON(json: any): ResearchSessionResponse {
    return ResearchSessionResponseFromJSONTyped(json, false);
}

export function ResearchSessionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResearchSessionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'researchSession': ResearchSessionFromJSON(json['research_session']),
    };
}

export function ResearchSessionResponseToJSON(json: any): ResearchSessionResponse {
    return ResearchSessionResponseToJSONTyped(json, false);
}

export function ResearchSessionResponseToJSONTyped(value?: ResearchSessionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'research_session': ResearchSessionToJSON(value['researchSession']),
    };
}

